import React from "react";
import { cn } from "../../utils/cn.ts";

interface IconButtonProps {
  icon: React.ReactNode;
  ariaLabel: string;
  onClick?: () => void;
  buttonClassName?: string;
  iconClassName?: string;
  isActive?: boolean;
}

// Base styles
const baseIconButtonStyle =
  "justify-center items-center gap-2.5 rounded-[999px] bg-loch shadow-xl " +
  "hover:bg-loch-700 focus-visible:ring-4 focus-visible:ring-loch-100 outline-none " +
  "active:bg-loch-700 active:shadow-icon-button-active";
const baseIconStyle = "justify-center shrink-0 aspect-square text-neutral-white text-center leading-none";

export const IconButton: React.FC<IconButtonProps> = ({
  icon,
  ariaLabel,
  onClick,
  buttonClassName = "",
  iconClassName = "",
  isActive = false,
}) => {
  const buttonStyle: string[] = [baseIconButtonStyle];
  const iconStyle: string[] = [baseIconStyle];

  return (
    <button
      className={cn(buttonStyle.join(" "), buttonClassName)}
      onClick={onClick}
      type="button"
      aria-pressed={isActive}
      aria-label={ariaLabel}
    >
      <span className={cn(iconStyle.join(" "), iconClassName)} aria-hidden="true">
        {icon}
      </span>
    </button>
  );
};
